module.exports = __webpack_public_path__ + "img/cases-brand-maxam-2.de742b1f.jpg";